var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticStyle:{"display":"table-cell","align-items":"center","text-align":"center","justify-content":"center","border-radius":"8px","padding":"15px 15px","width":"200px","vertical-align":"middle","text-decoration":"none","line-height":"1.5","font-size":"16px","font-weight":"500"},style:({
    backgroundColor: _vm.bgColor,
    color: _vm.textColor,
    margin: _vm.margin,
    border: _vm.borderBtn,
  }),attrs:{"href":_vm.href,"target":"_blank"}},[_vm._v(" "+_vm._s(_vm.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }